import React from 'react'
import { getImage, IGatsbyImageData } from 'gatsby-plugin-image'
import { BgImage } from 'gbimage-bridge'

export type BackgroundImageProps = {
  classname?: string
  gatsbyImageData?: IGatsbyImageData
  backgroundColor?: string
  Tag?: string
  children?: React.ReactNode
  role?: string
}

export const BackgroundImage = ({
  classname,
  gatsbyImageData,
  backgroundColor,
  Tag = 'div',
  children,
  role
}: BackgroundImageProps) => {
  const imageData = getImage(gatsbyImageData)
  const backgroundGradient = 'linear-gradient(108deg, #3e5151 0%, #decba4 100%)'

  if (imageData) {
    const backgroundImageStack = [imageData, backgroundGradient]

    return (
      <BgImage
        role={role}
        image={backgroundImageStack as any}
        className={classname}
        Tag={Tag}
        data-gradient-blend="true"
      >
        {children}
      </BgImage>
    )
  }

  // Fallback with background color/gradient
  const TagComponent = Tag as any
  const fallbackStyle = backgroundColor
    ? { backgroundColor }
    : { backgroundImage: backgroundGradient }

  return (
    <TagComponent role={role} className={classname} style={fallbackStyle}>
      {children}
    </TagComponent>
  )
}

export default BackgroundImage
